/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 (function() {
 	var tabs = document.getElementsByClassName('Product__Tabs');
 	var tabButtons = tabs[0].getElementsByClassName('Collapsible');
 	var accordionBtn = tabButtons[0].getElementsByTagName('button');
var button = accordionBtn[0]; //grab the element
button.click();
})();

const isMultiPhoto = document.body.classList.contains('template-multi-photo-product');
if (isMultiPhoto) {

// const sliderGallery = new Flickity('.Product__Slideshow');
// sliderGallery.destroy();
// const navGallery = document.querySelector(".Product__SlideshowMobileNav");
// navGallery.classList.add("no-show");

document.addEventListener('variant:changed', function(event) {
var variant = event.detail.variant; // Gives you access to the whole variant details

// console.log(variant.title);

const product_media = document.querySelectorAll(".Product__Slideshow .Carousel__Cell");
product_media.forEach(function (element) {
	let imgAltText = element.getAttribute('data-alt');
	if(imgAltText == variant.title){
		element.classList.remove("is-filtered");
	}else{
		element.classList.add("is-filtered");
	}
});

const sliderGallery = new Flickity('.Product__Slideshow');
sliderGallery.destroy();
// const navGallery = document.querySelector(".Product__SlideshowMobileNav");
// navGallery.classList.add("no-show");

const filteredGallery = new Flickity('.Product__Slideshow', {
	cellSelector: ".Product__SlideItem:not(.is-filtered)",
});

});
}

